<template>
  <tr
    class="d-flex table-row"
    :class="[
      { removeCursor, active, hovering, selected, nonSelected: !selected },
    ]"
  >
    <slot></slot>
  </tr>
</template>

<script>

export default {
  props: {
    removeCursor: {
      type: Boolean,
      required: false,
    },
    active: {
      type: Boolean,
      required: false,
    },
    position: {
      type: Number,
      required: false,
    },
    selected: {
      type: Boolean,
      required: false,
    },
  },
  created() {
    window.addEventListener("pointermove", this.onMove, {passive: true})
  },
  beforeDestroy() {
    window.removeEventListener("pointermove", this.onMove)
  },
  data() {
    return {
      hovering: false,
    }
  },
  methods: {
    onMove(evt) {
      const path = evt.composedPath()
      let found = false

      for (const node of path) {
        if (node.localName === "tr") {
          if (node === this.$el) {
            found = true
          }
          break
        }
      }

      this.hovering = found
    },
  },
}

</script>

<style scoped>

tr {
  cursor: pointer;
  padding-left: 0px;
  padding-right: 0px;
  width: 100%;
  overflow: visible;
}

tr {
  border-top: 1px solid rgba(200, 200, 200, .4);
}

.removeCursor {
  cursor: initial;
}

.selected + .nonSelected {
  border-top: none;
}

.selected {
  border: 1px solid #c7e5eb !important;
  background-color: rgba(50, 202, 210, .08) !important;
  border-left: none;
  border-right: none;
  width: calc(100% + 2px);
  margin-left: -1px;
}

.selected + .selected {
  border-top: none !important;
}

.hovering {
  background-color: #f6f7f8 !important;
}

</style>
